import type { TelephonyProjection, TelephonyReviewState } from '../../../../services/dialerApi'

export type SectionId = 'numbers' | 'callbacks' | 'recordings' | 'reputation' | 'crm'
// todo: the admin has something to do. wait: submitted, someone else acts next.
export type DotKind = 'todo' | 'wait' | 'none'

export const PHONE_SETTINGS_SECTIONS: { id: SectionId; tab: string; title: string }[] = [
  { id: 'numbers', tab: 'Numbers', title: 'Team numbers' },
  { id: 'callbacks', tab: 'Callbacks', title: 'Inbound callbacks' },
  { id: 'recordings', tab: 'Recordings', title: 'Call recordings & hours' },
  { id: 'reputation', tab: 'Reputation', title: 'Caller reputation' },
  { id: 'crm', tab: 'CRM', title: 'CRM export' },
]

export const sectionDomId = (id: string) => `ps-${id}`

export const inReview = (s: TelephonyReviewState) => s === 'pending_review' || s === 'in_review'
export const spamLabelOn = (p: TelephonyProjection) => p.voice_integrity.enabled || p.voice_integrity.state === 'approved'

// Mirrors what PhoneSettingsPage renders: a rejected review has no resubmit path
// (its view only says we'll be in touch), so it waits rather than asks.
function reputationDot(p: TelephonyProjection): DotKind {
  const bp = p.business_profile.state
  if (p.voice_integrity.locked) {
    return inReview(bp) || bp === 'rejected' ? 'wait' : 'todo'
  }
  const vi = p.voice_integrity
  if (spamLabelOn(p)) return 'none'
  if (inReview(vi.state) || vi.state === 'rejected') return 'wait'
  return 'todo'
}

export function sectionDots(p: TelephonyProjection): Record<SectionId, DotKind> {
  return {
    // Provisioning adopts or buys the first number itself.
    numbers: p.provisioning.status === 'provisioned' && p.pool.count === 0 ? 'todo' : 'none',
    callbacks: p.callback_default.verified ? 'none' : 'todo',
    recordings: 'none',
    reputation: reputationDot(p),
    crm: 'none',
  }
}

export function mostUrgent(kinds: DotKind[]): DotKind {
  if (kinds.includes('todo')) return 'todo'
  if (kinds.includes('wait')) return 'wait'
  return 'none'
}
